import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import UserLogsSection from "./user-logs-section";

export default function UserLogsPage() {
  return (
    <>
      <Header />
      <UserLogsSection />
    </>
  );
}
